import React from 'react';
import BestSellersBlockComponent from './BestSellersBlock.component';
import { Product } from '@/interfaces';

interface BestSellersBlockProps {
  data: {
    header: string;
    subheader: string;
    products: Product[];
  };
}

const BestSellersBlock = (props: BestSellersBlockProps): JSX.Element => {
  const { data } = props;

  return data?.products && <BestSellersBlockComponent data={data} />;
};

export default BestSellersBlock;
